import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarIcon, StackIcon } from '../../../../../../../styles';
import { StyledIconButton } from './shared-styles';

interface DisplayStackToggleProps {
  showStack: boolean;
  onClick: () => void;
}

export const DisplayStackToggle = (props: DisplayStackToggleProps) => {
  const { showStack, onClick } = props;
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Tooltip
      title={t('common:commonValues.tooltips.toggleStack')}
      placement="top"
    >
      <StyledIconButton
        onClick={handleClick}
        size="small"
        aria-label="Toggle Stack"
      >
        {showStack ? <BarIcon /> : <StackIcon />}
      </StyledIconButton>
    </Tooltip>
  );
};
